(async function loadOderStorefront() {
  const root = document.getElementById('oder-app-root');
  if (!root || root.dataset.loaded === 'true') return;
  root.dataset.loaded = 'true';

  try {
    const response = await fetch(window.ODER_FRAGMENT_URL, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Sayfa içeriği yüklenemedi: ' + response.status);
    root.innerHTML = await response.text();

    const runtime = document.createElement('script');
    runtime.src = window.ODER_RUNTIME_URL;
    runtime.async = true;
    document.body.appendChild(runtime);
  } catch (error) {
    console.error('ÖDER ENERJİ tema yükleme hatası:', error);
    root.innerHTML = '<main class="container" style="padding:56px 0"><h1 style="color:#082f5d">ÖDER ENERJİ Mağazası</h1><p>Sayfa içeriği yüklenirken kısa süreli bir sorun oluştu. Lütfen sayfayı yenileyin.</p></main>';
  }
})();
